import {
  DefaultConstraints,
  LowConstraints,
  PeerConfig
} from "@/tools/config.js";
import SimplePeer from "simple-peer";

export default class Regular {
  constructor(data, stream) {
    this.g = data;
    this.stream = stream;

    this.stream.getVideoTracks()[0].onended = () => {
      data.$socket.emit("close regular private", this.roomID);
      for (let i = 0; i < data.users.length; i++) {
        if (data.users[i].peer) {
          data.users[i].peer.destroy();
        }
      }
      this.g.$root.$alert("Notice", "Your room has been closed.");
      this.g.sockets.unsubscribe("join private regular");
      this.g.sockets.unsubscribe("update users");
      this.g.sockets.unsubscribe("viewer private regular receive host signal");
      this.g.sockets.unsubscribe("reconnect");
      this.g.closeHost();
    };
    this.stream.getVideoTracks()[0].applyConstraints(DefaultConstraints.video);
    this.sockets();
  }
  init() {
    let user = this.g.user;
    let roomName = this.g.privateRoomName;
    let roomDescription = this.g.privateRoomDescription;
    this.g.$socket.emit(
      "host regular private",
      { user, roomName, roomDescription },
      output => {
        if (output == "invalid token") this.g.$root.logout();
        if (output == "invalid input") {
          this.g.$root.$alert("Error", "Your room name is invalid.", {
            color: "red"
          });
        } else if (output.return == "success") {
          this.g.setStream(this.stream);
          this.g.privateRoom = false;
          this.roomID = output.roomID;
          this.g.roomID = output.roomID;
          this.g.roomName = roomName;
          this.g.roomDescription = roomDescription;
        }
      }
    );
  }
  changeQuality(quality) {
    if (quality == "low") {
      this.stream.getVideoTracks()[0].applyConstraints(LowConstraints.video);
    } else if (quality == "high") {
      this.stream
        .getVideoTracks()[0]
        .applyConstraints(DefaultConstraints.video);
    }
  }

  sockets() {
    this.g.sockets.subscribe("join private regular", object => {
      let newPeer = false;
      for (let i = 0; i < this.g.users.length; i++) {
        if (this.g.users[i].id == object.user.id) {
          newPeer = this.g.users[i].peer;
          break;
        }
      }
      if (!newPeer) {
        newPeer = new SimplePeer({
          initiator: true,
          trickle: true,
          stream: this.stream,
          config: PeerConfig
        });
        object.user.peer = newPeer;
        this.g.users.push(object.user);
        newPeer.on("signal", data => {
          this.g.$socket.emit("join private regular callback", {
            id: object.user.id,
            signal: data
          });
        });
      }
    });

    this.g.sockets.subscribe("update users", users => {
      let difference = this.g.users.filter(x => !users.includes(x));
      for (let i = 0; i < difference.length; i++) {
        if (difference[i].peer) {
          difference[i].peer.destroy();
        }
      }
      this.g.users = users;
    });

    this.g.sockets.subscribe(
      "viewer private regular receive host signal",
      object => {
        let signal = object.signal;
        let userID = object.userID;

        for (let i = 0; i < this.g.users.length; i++) {
          if ("peer" in this.g.users[i]) {
            if (this.g.users[i].id == userID) {
              this.g.users[i].peer.signal(signal);
            }
          }
        }
      }
    );

    this.g.sockets.subscribe("reconnect", () => {
      if (this.g.streaming)
        this.g.$socket.emit("reconnection", {
          user: this.g.user,
          roomID: this.roomID
        });
    });
  }

  close(callback) {
    this.stream.getVideoTracks().forEach(track => track.stop());
    this.g.$socket.emit("close regular private", this.roomID);
    for (let i = 0; i < this.g.users.length; i++) {
      if (this.g.users[i].peer) {
        this.g.users[i].peer.destroy();
      }
    }
    this.g.sockets.unsubscribe("join private regular");
    this.g.sockets.unsubscribe("update users");
    this.g.sockets.unsubscribe("viewer private regular receive host signal");
    this.g.sockets.unsubscribe("reconnect");
    this.g.closeHost();
    callback();
  }
}
